import { type CartContextItem } from 'providers/cart'
import {
  type ExecuteDataToDataLayerProps,
  GA4_EVENTS,
} from 'providers/googleAnalytics'
import { type CartOperationTransformationContextData } from 'providers/googleAnalytics/transformations'

interface CartOperationTrackingInput {
  executeDataToDataLayer: (
    props: ExecuteDataToDataLayerProps<CartOperationTransformationContextData>
  ) => void
  cartQuantity: number
  quantityToSet: number
  cartItem: CartContextItem
}

export const onSetItemTracking = ({
  executeDataToDataLayer,
  cartQuantity,
  quantityToSet,
  cartItem,
}: CartOperationTrackingInput) =>
  executeDataToDataLayer({
    event:
      cartQuantity > quantityToSet
        ? GA4_EVENTS.REMOVE_FROM_CART
        : GA4_EVENTS.ADD_TO_CART,
    overrideData: {
      cartItem,
      quantity: Math.abs(cartQuantity - quantityToSet),
    },
  })

export const onRemoveItemTracking = ({
  executeDataToDataLayer,
  cartQuantity,
  cartItem,
}: Omit<CartOperationTrackingInput, 'quantityToSet'>) =>
  executeDataToDataLayer({
    event: GA4_EVENTS.REMOVE_FROM_CART,
    overrideData: {
      cartItem,
      quantity: cartQuantity,
    },
  })
